import { RootState } from '../../../../redux/store';

export const selectChatSessionsById = (state: RootState) => state.chatSessions.byId;
